module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Cryptid Solver","description":""},"fi":{"pageTitle":"Cryptid Ratkaisin","description":""}}')
  delete Component.options._Ctor
}
